import * as d3 from "d3";

const $d3Chart = {
    donut(data, {
        delayTransition = 1,
        area = "#chart-area", // the element this append data
        centerText = "", // text center of donut chart
        centerDesc = "", // text description of donut chart
        name = ([x]) => x,  // given d in data, returns the (ordinal) label
        value = ([, y]) => y, // given d in data, returns the (quantitative) value
        title, // given d in data, returns the title text
        width = 250, // outer width, in pixels
        height = 250, // outer height, in pixels
        innerRadius = Math.min(width, height) / 4, // inner radius of pie, in pixels (non-zero for donut)
        outerRadius = Math.min(width, height) / 2, // outer radius of pie, in pixels
        labelRadius = (innerRadius + outerRadius) / 2, // center radius of labels
        format = ",", // a format specifier for values (in the label)
        names, // array of names (the domain of the color scale)
        colors, // array of colors for names
        stroke = innerRadius > 0 ? "none" : "white", // stroke separating widths
        strokeWidth = 1, // width of stroke separating wedges
        strokeLinejoin = "round", // line join of stroke separating wedges
        padAngle = stroke === "none" ? 1 / outerRadius : 0, // angular separation between wedges
    } = {}) {
        // Compute values.
        const N = d3.map(data, name);
        const V = d3.map(data, value);
        const I = d3.range(N.length).filter(i => !isNaN(V[i]));

        // Unique the names.
        if (names === undefined) names = N;
        names = new d3.InternSet(names);

        // Chose a default color scheme based on cardinality.
        if (colors === undefined) colors = d3.schemeSpectral[names.size];
        if (colors === undefined) colors = d3.quantize(t => d3.interpolateSpectral(t * 0.8 + 0.1), names.size);

        // Construct scales.
        const color = d3.scaleOrdinal(names, colors);

        // Compute titles.
        if (title === undefined) {
            const formatValue = d3.format(format);
            title = i => `${N[i]}\n${formatValue(V[i])}`;
        } else {
            const O = d3.map(data, d => d);
            const T = title;
            title = i => T(O[i], i, data);
        }

        // Construct arcs.
        const arcs = d3.pie().padAngle(padAngle).sort(null).value(i => V[i])(I);
        const arc = d3.arc().innerRadius(innerRadius).outerRadius(outerRadius);
        const arcLabel = d3.arc().innerRadius(labelRadius).outerRadius(labelRadius);
        // Get svg area
        const svg = d3.select(area)
            .selectAll('svg')
            .attr("width", width)
            .attr("height", height)
            .attr("viewBox", [-width / 2, -height / 2, width, height])
            .attr("style", "max-width: 100%; height: auto; height: intrinsic;");
        // Render angle
        const angleGroup = svg.selectAll('.angle')
            .attr("class", "angle")
            .attr("stroke", stroke)
            .attr("stroke-width", strokeWidth)
            .attr("stroke-linejoin", strokeLinejoin);
        const anglePath = angleGroup
            .selectAll("path")
            .data(arcs)
        //Remove old angle path data
        anglePath.exit().remove()
        anglePath
            .join("path")
            .attr("fill", d => color(N[d.data]))
            .transition().delay(function (d, i) {
                return i * delayTransition;
            }).duration(delayTransition)
            .attrTween('d', function (d) {
                var i = d3.interpolate(d.startAngle + 0.1, d.endAngle);
                return function (t) {
                    d.endAngle = i(t);
                    return arc(d);
                }
            });
        // Render text in angle
        const textAngleGroup = svg
            .selectAll('.text-angle')
            .attr("font-family", "sans-serif")
            .attr("font-size", 10)
            .attr("text-anchor", "middle");
        const textAngleText = textAngleGroup
            .selectAll("text")
            .data(arcs)
        //Remove ole angle text
        textAngleText.exit().remove()

        textAngleText
            .join("text")
            .attr("transform", d => `translate(${arcLabel.centroid(d)})`)
            .selectAll("tspan")
            .data(d => {
                const lines = `${title(d.data)}`.split(/\n/);
                return (d.endAngle - d.startAngle) > 0.25 ? lines : lines.slice(0, 1);
            })
            .join("tspan")
            .attr("x", 0)
            .attr("y", (_, i) => `${i * 1.1}em`)
            .attr("font-weight", (_, i) => i ? null : "bold")
            .attr("fill", "white")
            .text(d => d);
        // Render center text
        const centerTextGroup = svg.selectAll('.center-text').data(centerText);
        // Remove old center text
        centerTextGroup.exit().remove();
        centerTextGroup
            .attr("transform", "translate(0,0)")
            .style("text-anchor", "middle")
            .style("font-size", "30px")
            .style("font-weight", "bold")
            .text(centerText);
        // Render center text description
        const centerTextDescGroup = svg.selectAll('.center-text-desc').data(centerDesc);
        //Remove old center text desc
        centerTextDescGroup.exit().remove()
        centerTextDescGroup.attr("transform", "translate(0,20)")
            .attr("font-size", "14px")
            .style("text-anchor", "middle")
            .text(centerDesc);
        return Object.assign(svg.node(), {scales: {color}});
    }
}
export default $d3Chart